<template>
  <div class="TwStore">
    <div class="container-fluid">
      <nav class="navbar navbar-expand-lg navbar-light bg-light">
        <a class="navbar-brand" href="#">代買台灣精選源頭工廠</a>
      </nav>
      <div class="row">
        <div
          class="col-6 col-sm-6"
          v-for="(product, index) in displayViews"
          v-bind:key="(product, index)"
        >
          <div class="card mt-3">
            <img v-lazy="product.main_image" class="card-img-top" alt />
            <div class="card-body">
              <h5 class="card-title">{{ product.product_name }}</h5>
              <p class="card-text">
                起批數:{{ product.price.limit_quantity_l1 }}
              </p>
              <p class="card-text">
                免運費數量:{{ product.free_freight_quantity }}
              </p>
              <p class="card-text">價格:</p>
              <p class="card-text">
                ≥ {{ product.price.limit_quantity_l1 }}(數量):
                {{ product.price.price_l1 }}台幣
              </p>
              <p class="card-text">
                ≥ {{ product.price.limit_quantity_l2 }} (數量):
                {{ product.price.price_l2 }}台幣
              </p>
              <p class="card-text">
                ≥ {{ product.price.limit_quantity_l3 }} (數量):
                {{ product.price.price_l3 }}台幣
              </p>
              <a
                href="#"
                class="btn btn-primary btn-block"
                @click="buy(product.vender.vender_id, product.product_id)"
                >選擇商品</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading
      loader="bars"
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="true"
    ></loading>
    <v-dialog />
  </div>
</template>
<style type="text/css">
input[type='number']::-webkit-outer-spin-button,
input[type='number']::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.prod-block {
  /* background-color: #ff0000; */
}

.prod-text {
  /* overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 200px; */
}

.title {
  font-size: x-large;
  padding: 10px 0px;
}

.sale-price {
  color: #ff0000;
}

.noProd {
  font-size: 30px;
  color: red;
}

.padding-top-block {
  padding-top: 10px;
}

.calculation-text {
  font-size: 13px;
  color: red;
}

.w-400 {
  /* width: 100%;
  height: 200px; */
  height: 200px;
  width: 200px;
  width: 100%;
  /* object-fit: cover; */
  /* width: 400px;
  height: 500px; */
}
</style>
<script>
import VueLoading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import axios from 'axios'

// import { isMobile } from "mobile-device-detect";
export default {
  name: 'TwStore',
  components: {
    loading: VueLoading,
  },
  data: function () {
    return {
      apiUrl: process.env.VUE_APP_API_URL,
      displayViews: null,
      isLoading: true,
    }
  },
  methods: {
    checkUnChatbotSignin: function () {
      const vm = this

      try {
        if (
          vm.$route.query.userId &&
          vm.$route.query.userImage &&
          vm.$route.query.userName
        ) {
          localStorage.userId = decodeURI(vm.$route.query.userId)
          localStorage.userImage = decodeURI(vm.$route.query.userImage)
          localStorage.userName = decodeURI(vm.$route.query.userName)
          vm.userId = decodeURI(vm.$route.query.userId)
          vm.userImage = decodeURI(vm.$route.query.userImage)
          vm.userName = decodeURI(vm.$route.query.userName)
        }
      } catch (e) {
        // console.info(e);
        alert(e)
      }

      if (
        localStorage.userId == undefined
        // localStorage.userImage == undefined ||
        // localStorage.userName == undefined
      ) {
        vm.$modal.show('dialog', {
          title: '🙋您尚未登入FB會員',
          text: '請先登入才能使用此服務喔⚡',
          buttons: [
            {
              title: '👉用FB登入',
              handler: () => {
                window.location = 'https://m.me/2266831083395361'
              },
            },
          ],
        })
        return true
      } else {
        return false
      }
    },
    getTwProduct: function () {
      const vm = this
      ;(async function post() {
        let formData = {}
        await axios
          .post(vm.apiUrl + 'GetTwProductByValide', formData, {
            headers: {
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'application/json',
            },
          })
          .then(function (response) {
            vm.displayViews = response.data
            vm.isLoading = false
          })
          .catch(function (error) {
            // console.log(error);
            vm.$toast.open({
              message: '網路異常: ' + error,
              type: 'error',
            })
          })
      })()
    },
    buy: function (venderId, productId) {
      const vm = this
      localStorage.selectVenderId = venderId
      localStorage.selectProductId = productId
      vm.$router.push('TwStoreVender')
    },
  },
  watch: {},
  computed: {},
  mounted() {
    const vm = this
    vm.isLoading = true
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    vm.checkUnChatbotSignin()
    vm.getTwProduct()
  },
}
</script>
